import React from 'react'

const TransactionsReview = () => {
  return (
    <>
      <div className="pagetitle">
        <h1>Transactions Review</h1>
        <nav>
          <ol className="breadcrumb">
            <li className="breadcrumb-item"><a href="#">Home</a></li>
            <li className="breadcrumb-item active">Transactions Review</li>
          </ol>
        </nav>
      </div>
      <section className="section">
        <div className="row">
          <div className="col-12">
            <div className="card">
              <div className="card-body">
                <h5 className="card-title">Transactions Review</h5>
                <p>Review and audit all system transactions.</p>
                {/* Add transactions review table/component here */}
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  )
}

export default TransactionsReview

